export * from "./LoseMessage.tsx";
export { default } from "./LoseMessage.tsx";
